import { BookOpen, FileText, Settings, Star } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

const features = [
  {
    title: "Curve Ai Chat",
    description: "Chat with Curve Ai to get instant explanations, ask questions, quiz yourself, and receive actionable study advice—all based on your uploaded materials.",
    icon: Star,
  },
  {
    title: "Multi-File Upload & Management",
    description: "Upload and manage multiple PDFs, DOCX, and TXT files at once. Combine books, syllabi, and reference papers for comprehensive analysis.",
    icon: FileText,
  },
  {
    title: "Mock Exams & Study Guides",
    description: "Generate custom practice exams, detailed study guides, and key topic lists tailored to your materials and syllabus.",
    icon: BookOpen,
  },
  {
    title: "Personalized Study Plans",
    description: "Let AI help you create a focused, step-by-step study plan based on your strengths, weaknesses, and exam goals.",
    icon: Settings,
  },
  {
    title: "Exam Expectations & Predictions",
    description: "Get AI-powered predictions on likely exam questions, important topics, and what to focus on next.",
    icon: Star,
  },
  {
    title: "Modern, Intuitive UI",
    description: "Enjoy a beautiful, distraction-free interface designed for productivity and ease of use on any device.",
    icon: Settings,
  },
];

const Features = () => {
  return (
    <section id="features" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="container px-4 sm:px-6 md:px-8 mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">Everything You Need for Smarter Studying</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">
            Discover the full power of Curve Ai: interactive chat, multi-file support, personalized outputs, and more.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <Card
                key={feature.title}
                className="border border-gray-200 hover:border-primary/50 transition-all duration-200 transform hover:scale-105 hover:shadow-2xl hover:bg-white/90 hover:brightness-105 cursor-pointer h-full"
              >
                <CardHeader>
                  <Icon className="h-8 w-8 sm:h-10 sm:w-10 text-primary mb-4" />
                  <CardTitle className="text-lg sm:text-xl md:text-2xl">{feature.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 text-sm sm:text-base">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features; 